module.exports = __webpack_public_path__ + "img/danielaRizzi.020b00b8.jpg";